(function() {
    'use strict';

    window.addEventListener('load', function() {

        var dropdown = document.querySelector('.hs-ville_et_date .hs-input');

        if (!dropdown) {
            return;
        } else {
            dropdown.addEventListener('change', function(event) {
                event.preventDefault();
                var selectedEvent = document.querySelector('#event_' + event.target.value);

                if (selectedEvent) {
                    document.querySelector('.event.is-active').classList.remove('is-active');
                    selectedEvent.classList.add('is-active');
                }

            });
        }

    });

})();
